<div class="container">
  <div class="formgrid grid">
    <div class="field grid col-8 align-items-baseline">
      <label class="col-1 column-label">{{ 'RFQImport.Forwarder' | translate }}</label>
      <div class="col-10 column-value">
        <p-dropdown  [(ngModel)]="forwarder" optionLabel="label"  optionValue="value"
                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                      [options]="forwarderOptions"  [filter]="true" filterBy="label"> </p-dropdown>
      </div>
    </div>

    <div class="field col-12">
        <label>{{ 'RFQImport.File' | translate }}</label>
        <p-fileUpload #fileUpload [customUpload]="true" (uploadHandler)="preview($event)"  (onClear)="onClear()"
            chooseLabel="{{ 'RFQImport.Select' | translate }}" uploadLabel="{{ 'RFQImport.Preview' | translate }}" cancelLabel="{{ 'RFQImport.Cancel' | translate }}" accept=".xls,.xlsx"   >

          <ng-template pTemplate="toolbar">
            <button #uploadBtn pButton pRipple label="{{ 'RFQImport.Upload' | translate }}"   class="p-button-success ml-1"  [disabled]="showUploadBtn()" (click)="upload()"></button>

            <button #uploadBtn pButton pRipple label="{{ 'RFQImport.RFQTemplate' | translate }}"   class="p-button-info ml-1"   (click)="templateDownloadBtn(0)"></button>
            <button #uploadBtn pButton pRipple label="{{ 'RFQImport.ImportExportTemplate' | translate }}"   class="p-button-info ml-1"   (click)="templateDownloadBtn(1)"></button>
          </ng-template>

          <ng-template pTemplate="content" let-files>
            <div  *ngIf="showTable1" >
              <p-table class="datatable" [value]="rfqSample"  [scrollable]="true"   [style]="{ 'overflow-y': 'auto' }"  [paginator]="true" [rows]="100"  >
                <ng-template pTemplate="body" let-row >
                  <tr>
                      <td *ngFor="let obj of row"  [ngStyle]="{'width':'200px'}" >{{obj}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>


            <div  *ngIf="showTable2" >
              <h3>Inbound</h3>
              <p-table class="datatable" [value]="inboundFormat"  [scrollable]="true"  [style]="{ 'overflow-y': 'auto' }" [paginator]="true" [rows]="100"   >
                <ng-template pTemplate="body" let-row >
                  <tr>
                      <td *ngFor="let obj of row"  [ngStyle]="{'width':'200px'}" >{{obj}}</td>
                  </tr>
                </ng-template>
              </p-table>


              <h3>Outbound</h3>
              <p-table class="datatable" [value]="outboundFormat"  [scrollable]="true"  [style]="{ 'overflow-y': 'auto' }" [paginator]="true" [rows]="100"   >
                <ng-template pTemplate="body" let-row >
                  <tr>
                      <td *ngFor="let obj of row"  [ngStyle]="{'width':'200px'}" >{{obj}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>



          </ng-template>
        </p-fileUpload>
    </div>



  </div>
</div>
